import React from 'react';import Box from '@material-ui/core/Box';
import './styles.css';
import logo from '../../../../extensions/images/empty-preview.png';

const TimelimeRotationLogoText = (props) => {
  const fullLink = createFullLink(props.image);
  return (
    <div className='footer-logo-box'>
      <div className='rotation-box'>
        <svg
          className='rounded-text'
          style={{
            letterSpacing: props.letterSpacing + 'px',
            fontSize: props.fontSize + 'px',
          }}
          viewBox='0 0 200 200'
        >
          <path
            id='textPath'
            d='M 85,0 A 85,85 0 0 1 -85,0 A 85,85 0 0 1 85,0'
            transform='translate(100,100)'
            fill='none'
            strokeWidth='0'
          ></path>
          <g>
            <text textAnchor='start'>
              <textPath href='#textPath' startOffset='0%'>
                {props.text}
              </textPath>
            </text>
          </g>
        </svg>

        <img
          className='no-rotation-image'
          height='167px'
          width='167px'
          src={fullLink || logo}
          alt='footer img rotation'
        />
      </div>
    </div>
  );
};

function createFullLink(imageLink) {
  if (!imageLink) return null;

  const isRemoteLink = /^(http:\/\/|https:\/\/)/.test(imageLink);
  if (isRemoteLink) return imageLink;

  const isBase64Image = /data:image\/\w+;base64,/.test(imageLink);
  if (isBase64Image) return imageLink;

  let AWSS3Url = process.env.REACT_APP_AWS_S3_URL || '';
  AWSS3Url = AWSS3Url.replace(/\/$/, '');
  return `${AWSS3Url}/${imageLink}`;
}

export default TimelimeRotationLogoText;
